// A camera sees one label on many frames: only its first read counts. Used
// by ScanCapture's continuous mode (a wizard scan loop, a stock count), so a
// label held in view is one scan, and the same label scanned again on purpose
// counts once it has left the view for the window.

/** `true` when `text` is a new read; `false` for a repeat of the last code
 *  seen within `windowMs` (each sighting restarts the window). */
export function createRepeatFilter(windowMs = 1500, now: () => number = () => Date.now()) {
  let last: { text: string; at: number } | null = null
  return (text: string): boolean => {
    const t = now()
    if (last && last.text === text && t - last.at < windowMs) {
      last = { text, at: t }
      return false
    }
    last = { text, at: t }
    return true
  }
}
